export default {
    geoRegions: {
        search: '/career/geo-regions.json',
    },
    geoRegionPreferences: {
        fetch: '/career/geo-region-preferences.json',
        create: '/career/geo-region-preferences.json',
        delete: '/career/geo-region-preferences/{preferenceId}.json',
    },
    preferencePrompt: {
        fetch: '/career/preference-prompt.json',
        save: '/career/preference-prompt.json',
    },
    notificationOptions: {
        fetch: '/career/notification-options.json',
        save: '/career/notification-options.json',
    },
    keywordPreferences: {
        fetch: '/career/keywords.json',
        save: '/career/keywords.json',
    },
};



// WEBPACK FOOTER //
// ./career-paths.js